"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Identity_1 = require("../identity/Identity");
const Router_1 = require("../router/Router");
const UI_1 = require("../ui/UI");
function App({ identity, ui, router, children, }) {
    if (router) {
        children = jsx_runtime_1.jsx(Router_1.RouterContextProvider, Object.assign({}, router, { children: children }), void 0);
    }
    if (identity) {
        children = jsx_runtime_1.jsx(Identity_1.IdentityContextProvider, Object.assign({}, identity, { children: children }), void 0);
    }
    if (ui) {
        children = jsx_runtime_1.jsx(UI_1.UIContextProvider, Object.assign({}, ui, { children: children }), void 0);
    }
    return jsx_runtime_1.jsx(react_1.StrictMode, { children: children }, void 0);
}
exports.App = App;
//# sourceMappingURL=App.js.map